export default {
  PUSH_MSG_DATA: "pushMsgData",
  USER_LIST_DATA: "userListData",
};
